var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditDate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42857 5.94866V9.42857H1.57143V1.57143H5.05134C5.14955 1.57143 5.22321 1.54688 5.27232 1.49777L6.25446 0.515625C6.42634 0.319196 6.30357 0 6.03348 0H1.17857C0.515625 0 0 0.540179 0 1.17857V9.82143C0 10.4844 0.515625 11 1.17857 11H9.82143C10.4598 11 11 10.4844 11 9.82143V4.96652C11 4.69643 10.6808 4.57366 10.4844 4.74554L9.50223 5.72768C9.45313 5.77679 9.42857 5.85045 9.42857 5.94866Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97187 1.27626L4.16703 5.0811L4.00279 6.64136C3.97542 6.84666 4.15334 7.02458 4.35864 6.99721L5.9189 6.83297L9.72374 3.02813L7.97187 1.27626ZM10.805 1.01622L9.98378 0.195032C9.73742 -0.0650107 9.31314 -0.0650107 9.0531 0.195032L8.28666 0.961475L10.0385 2.71334L10.805 1.9469C11.065 1.68686 11.065 1.26258 10.805 1.01622Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditDate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editDate.2acc9456.svg";
export { ForwardRef as ReactComponent };